import React, { useState } from 'react';
import { submitFeedback } from '../api/chatApi';

const STARS = [1, 2, 3, 4, 5];
const FEEDBACK_MAX_LENGTH = 200;

function FeedbackBar({ sessionId, uuid }) {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const feedbackRequired = rating >= 1 && rating <= 3;
  const canSubmit = rating > 0 && (!feedbackRequired || feedback.trim() !== '') && !submitting;

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      await submitFeedback(sessionId, uuid, rating, feedback.trim());
      setSubmitted(true);
    } catch (err) {
      console.error('Failed to submit feedback:', err);
      setError('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="feedback-bar">
        <span className="feedback-text">Thank you for your feedback!</span>
      </div>
    );
  }

  const activeCount = hoverRating || rating;

  return (
    <div className="feedback-bar">
      <span className="feedback-text">How satisfied are you with the support?</span>
      <div className="feedback-stars">
        {STARS.map((star) => (
          <button
            key={star}
            type="button"
            className={`feedback-star${star <= activeCount ? ' active' : ''}`}
            aria-label={`${star} star${star > 1 ? 's' : ''}`}
            aria-pressed={rating === star}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
          >
            ★
          </button>
        ))}
      </div>
      <label className="feedback-label" htmlFor="feedback-input">
        {feedbackRequired ? 'Feedback (required)' : 'Feedback (optional)'}
      </label>
      <textarea
        id="feedback-input"
        className="feedback-input"
        rows={3}
        value={feedback}
        maxLength={FEEDBACK_MAX_LENGTH}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder={feedbackRequired ? 'Please tell us what went wrong...' : 'Share your feedback...'}
      />
      <div className="feedback-footer">
        <span className="feedback-counter">{feedback.length}/{FEEDBACK_MAX_LENGTH}</span>
        {error && <span className="feedback-error">{error}</span>}
        <button type="button" className="feedback-submit-btn" onClick={handleSubmit} disabled={!canSubmit}>
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
}

export default FeedbackBar;
